<template>
  <a-config-provider :locale="locale" :get-popup-container="popContainer">
    <router-view />
  </a-config-provider>
</template>

<script>
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN'
import { mapState, mapMutations } from 'vuex'
import themeUtil from '@/utils/themeUtil'

export default {
  name: 'App',
  data() {
    return {
      locale: zhCN,
    }
  },
  created() {
    this.setHtmlTitle()
  },
  mounted() {
    this.setWeekModeTheme(this.weekMode)
    const body = document.body
    const theme = this.$store.state.setting.theme
    Object.keys(theme).forEach((key) => {
      body.style.setProperty(`--${key}`, `${theme[key]}`)
    })
    window.addEventListener('unload', this.savequery, { once: true })
  },
  watch: {
    weekMode(val) {
      this.setWeekModeTheme(val)
    },
    lang(val) {
      this.setHtmlTitle()
    },
    $route() {
      this.setHtmlTitle()
    },
    'theme.mode': function (val) {
      let closeMessage = this.$message.loading(`您选择了主题模式 ${val}, 正在切换...`)
      themeUtil.changeThemeColor(this.theme.color, val).then(closeMessage)
    },
    'theme.color': function (val) {
      let closeMessage = this.$message.loading(`您选择了主题色 ${val}, 正在切换...`)
      themeUtil.changeThemeColor(val, this.theme.mode).then(closeMessage)
    },
    layout: function () {
      window.dispatchEvent(new Event('resize'))
    },
  },
  computed: {
    ...mapState('setting', ['layout', 'theme', 'weekMode', 'lang']),
  },
  methods: {
    ...mapMutations('setting', ['setDevice']),
    savequery() {
      sessionStorage.setItem('breadcrumb-query', JSON.stringify(this.$store.state.account.query))
    },
    setWeekModeTheme(weekMode) {
      if (weekMode) {
        document.body.classList.add('week-mode')
      } else {
        document.body.classList.remove('week-mode')
      }
    },
    getPopupContainer(triggerNode) {
      if (triggerNode && !this.isParent(triggerNode.parentElement, 'ant-table')) {
        return triggerNode.parentNode
      }
      return document.body
    },
    setHtmlTitle() {
      const route = this.$route
      document.title = route.meta.title ? '大脑课堂管理系统 | ' + route.meta.title : '大脑课堂管理系统'
    },
    popContainer(triggerNode) {
      if (triggerNode && triggerNode.tagName.toLocaleLowerCase() === 'i') {
        return document.getElementById('popContainer')
      }
      if (triggerNode && !this.isParent(triggerNode.parentElement, 'ant-table')) {
        return triggerNode.parentNode
      }
      return document.getElementById('popContainer')
    },
    isParent(el, className) {
      if (el && el.parentElement && el.tagName.toLowerCase() !== 'body') {
        let name = el.getAttribute('class')
        if (name && name.split(' ').includes(className)) {
          return true
        } else {
          return this.isParent(el.parentElement, className)
        }
      }
      return false
    },
  },
}
</script>

<style lang="css">
.disabled-btn {
  color: #999;
  cursor: not-allowed;
  pointer-events: none;
}
</style>
<style lang="less">
@import 'utils/aliIconfont/iconfont.css';

.operate {
  .ant-btn-link {
    padding: 0;

    &:not(:last-child) {
      margin-right: 10px;
    }

    .anticon + span {
      margin-left: 3px;
    }

    &[danger]:not([disabled='disabled']) {
      color: @error-color;
    }
  }
}

.action a {
  margin-right: 10px;
  white-space: nowrap;
}

.action i,
.action em {
  font-style: normal;
}

.action[disabled='disabled'] {
  pointer-events: none;
  color: #ddd !important;
}

.action[disabled='disabled'] a {
  pointer-events: none;
  color: #ccc !important;
}

.action a span {
  margin-right: 10px;
  color: #bbb;
  cursor: default;
}

.action a.red,
.action .c-red {
  color: red;
}

.action .c-red:hover {
  color: red;
}
.c-theme {
  color: var(--color);
}
.action .ant-btn-link {
  padding: 0;
  margin-right: 10px;

  span {
    margin-left: 5px !important;
  }
}

.action .ant-btn-link {
  padding: 0;
  margin-right: 10px;

  span {
    margin-left: 5px !important;
  }
}

.badge .ant-badge {
  white-space: nowrap;
}

.ant-form .serach-item {
  width: 180px;
  margin-bottom: 15px;
}

.search-form.ant-form-inline .ant-form-item {
  margin-bottom: 15px;
}

.search-form .ant-select,
.search-form .ant-input-affix-wrapper {
  width: 180px;
}

.no-click {
  pointer-events: none;
}

.no-drop {
  cursor: no-drop;
}

textarea.ant-input {
  word-break: break-all;
}
.ant-table-body tr td .ant-btn-link:first-child {
  padding-left: 0;
}
</style>
